module.exports = __webpack_public_path__ + "img/tab1-active.6b96acf3.png";